import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  text-align: left;
  position: relative;
  color: var(--grey-0);
  background: var(--menu-color);
  border-radius: 15px;

  padding: 35px;

  h2 {
    margin-bottom: 1em;
    color: var(--grey-0);
  }

  h3 {
    margin: 1.25em 0 0.5em;
    font-size: 1rem;
    font-weight: 600;
    color: var(--grey-0);
  }

  p {
    margin-bottom: 0.5em;
    color: var(--grey-0);
  }

  .close {
    position: absolute;
    top: 15px;
    right: 15px;
    cursor: pointer;
    color: var(--primary-cta-high-contrast);
    font-weight: 500;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  button {
    margin: 10px 10px 10px 0;
    cursor: pointer;
    font-family: Inter, system-ui, sans-serif;
    border-radius: 20px;
    border: 1.5px solid var(--primary-cta);
    background: var(--primary-cta);
    font-weight: 500;
    font-size: 14px;
    line-height: 191%;
    padding: 8px 15px;
    min-width: 210px;
    color: var(--cta-text-color);
  }

  button:disabled {
    cursor: not-allowed;
    opacity: 0.55;
  }

  .json {
    font-family: monospace;
    height: 350px;
    overflow: scroll;
    background: var(--text-field-background);
    color: var(--grey-0);
    padding: 10px;
    border-radius: 8px;
    border: 1px solid var(--divider);
  }

  .gates-list {
    max-height: 280px;
    overflow: auto;
    padding: 4px 0;
    margin: 0 -4px;
    border-top: 1px solid var(--divider);
    border-bottom: 1px solid var(--divider);
  }

  .gate-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 6px 4px;
    font-size: 14px;
  }

  .gate-row label {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    flex: 1;
    color: var(--grey-0);
  }

  .gate-row input[type="checkbox"] {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    cursor: pointer;
    accent-color: var(--primary-cta);
  }

  .gate-error {
    color: var(--danger-color);
    font-size: 13px;
    margin-top: 8px;
  }

  .gates-note {
    font-size: 13px;
    color: var(--grey-1);
    margin-bottom: 8px;
  }

  button.close {
    background: transparent;
    border: none;
    padding: 0;
    min-width: unset;
    font: inherit;
    font-weight: 500;
    color: var(--primary-cta-high-contrast);
    margin: 0;
    text-decoration: none;
    box-shadow: none;

    &:hover {
      text-decoration: underline;
    }
  }

  label.inline-check {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    color: var(--grey-0);
  }

  label.inline-check input[type="checkbox"] {
    width: 18px;
    height: 18px;
    accent-color: var(--primary-cta);
  }
`;
